export default __webpack_public_path__ + "public/images/GetAttachmentThumbnail.png?d520a8c7";